import {combineReducers} from 'redux';
import creditMethods from './credit-methods.reducer';
import bankMethods from './bank-methods.reducer';

const paymentMethodsReducer = combineReducers({
	creditMethods,
	bankMethods
});

export default paymentMethodsReducer;